import { Box, Button, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import EditIcon from "@mui/icons-material/BorderColorOutlined";
import styleCss from "../Style/style";
import StarImg from "../img/staricon.png";
import TotalIconBook from "../img/total-icon.png";
import TotalIconBook1 from "../img/locationnew-icon.png";
import TotalIconBook2 from "../img/outerrating.png";
import LocationImg from "../img/safty-icon2.png";
import { AuthAxios } from "../Utilities/CommonAxios";
import { useEffect, useState } from "react";
import showToast from "../Utilities/showToast";
import SaveIcon from "@mui/icons-material/Save";
import { useFormik } from "formik";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import * as Yup from "yup";

const MyProfile = () => {
  const [profiledata, setProfileData] = useState({ dob: "" });
  const [routes, setRoutes] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  
  const getprofiledata = async () => {
    try {
      const response = await AuthAxios({
        url: "/get_profile",
        method: "post",
        payload: {},
      });

      if (response.status) {
        const data = response.data || {};
        setProfileData(data);
      }
    } catch (error) {
      showToast("error", error.message);
    }
  };
  const editprofile = async (values) => {
    try {
      const response = await AuthAxios({
        url: "/edit_profile",
        method: "post",
        payload: {
          first_name: values.first_name,
          last_name: values.last_name,
          dob: values.dob,
          gender: values.gender,
        },
      });

      if (response.status) {
        showToast("success", "Profile updated successfully");
        console.log("Response:", response.data);
        getprofiledata();
      } else {
        showToast("error", "Profile update failed");
      }
    } catch (error) {
      showToast("error", error.message);
    }
  };
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      gender: "",
      dob: "",
      number_of_booking: "",
      cities_visited: "",
      saved_routes: "",
    },
    onSubmit: async (values) => {
      console.log("Updated profile:", values);
      await editprofile(values);
    },
  });
  const handleEditSave = async () => {
    if (isEditable) {
      await formik.submitForm();
    }
    setIsEditable(!isEditable);
  };

  useEffect(() => {
    getprofiledata();
  }, []);

  useEffect(() => {
    if (profiledata && Object.keys(profiledata).length > 0) {
      formik.setValues({
        first_name: profiledata.first_name || "",
        last_name: profiledata.last_name || "",
        email: profiledata.email || "",
        phone_number: profiledata.phone_number || "",
        gender: profiledata.gender || "",
        dob: profiledata.dob || "",
        number_of_booking: profiledata.number_of_booking || "",
        cities_visited: profiledata.cities_visited || "",
        saved_routes: profiledata.saved_routes || "",
      });

      if (profiledata.saved_routes) {
        try {
          const parsedRoutes = JSON.parse(profiledata.saved_routes);
          setRoutes(parsedRoutes);
        } catch (err) {
          console.error("Error parsing saved_routes:", err);
          setRoutes([]);
        }
      } else {
        setRoutes([]);
      }
    }
  }, [profiledata]);
  return (
    <Grid container spacing={2}>
      <Grid size={{ md: 8, xs: 12 }}>
        <Box
          sx={{
            padding: "33px 20px",
            borderRadius: "20px",
            border: "1px solid #e5e5e5",
            backgroundColor: "#fff",
            "@media (max-width:600px)": {
              padding: "20px",
            },
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", alignItems: "center", marginBottom: "20px" }}
          >
            <Grid size={{ md: 9, xs: 12 }}>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "17px",
                  fontWeight: 600,
                  textAlign: "left",
                  color: "#0e182b",
                }}
              >
                Personal Information
              </Typography>
            </Grid>
            <Grid
              size={{ md: 3, xs: 12 }}
              sx={{
                textAlign: "end",
                "@media (max-width:600px)": {
                  textAlign: "unset",
                },
              }}
            >
              <Button
                variant="outlined"
                onClick={handleEditSave}
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "15px",
                  textAlign: "center",
                  color: "#000",
                  borderRadius: "6px",
                  border: "solid 1px #d1d5db",
                  textTransform: "capitalize",
                }}
              >
                {isEditable ? <SaveIcon /> : <EditIcon />}
                {isEditable ? "Save" : "Edit"}
              </Button>
              {/* <Button
                variant="outlined"
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "15px",
                  textAlign: "center",
                  color: "#000",
                  borderRadius: "6px",
                  border: "solid 1px #d1d5db",
                  textTransform: "capitalize",
                }}
              >
                <EditIcon /> Edit
              </Button> */}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid sx={{ display: "flex", alignItems: "center" }}>
              <Grid sx={{ marginRight: "15px" }}>
                <Typography
                  sx={{
                    padding: "10px",
                    borderRadius: "60px",
                    backgroundColor: "#ececf0",
                    fontFamily: '"Segoe UI", sans-serif',
                    fontSize: "16px",
                    fontWeight: "600",
                    textAlign: "center",
                    color: "#000",
                    height: "60px",
                    width: "60px",
                    display: "grid",
                    placeContent: "center",
                  }}
                >
                  MA
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={styleCss.ProfileHead}>
                  {/* Rahul Sharma   */}
                  {profiledata.first_name && profiledata.last_name
                    ? `${profiledata.first_name} ${profiledata.last_name}`
                    : ""}
                </Typography>
                <Typography sx={styleCss.Subheading}>
                  Member since Jan 2023
                </Typography>
                <Typography sx={styleCss.Subheading}>
                  <img
                    alt=""
                    src={StarImg}
                    style={{ verticalAlign: "middle" }}
                  />{" "}
                  4.8 Rating
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "20px" }}>
            <Grid size={{ md: 6, xs: 12 }}>
              <Typography sx={styleCss.CommonLabelName}>First Name:</Typography>
              <TextField
                variant="outlined"
                size="small"
                placeholder="First Name"
                fullWidth
                disabled={!isEditable}
                name="first_name"
                value={formik.values.first_name}
                onChange={formik.handleChange}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f3f3f5",
                    borderRadius: "8px",
                    minHeight: "32px",
                    padding: 0,
                    "& input": {
                      padding: "12px 10px",
                      fontSize: "15px",
                      "&::placeholder": {
                        fontSize: "15px",
                        color: "#717182",
                        opacity: 1,
                        fontFamily: '"Segoe UI", sans-serif',
                      },
                    },
                    "& fieldset": { borderColor: "#ddd" },
                    "&:hover fieldset": { borderColor: "#bbb" },
                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                  },
                  "& .MuiInputLabel-root": {
                    fontFamily: '"Segoe UI", sans-serif',
                    fontSize: "15px",
                    color: "#364252",
                  },
                }}
              />
            </Grid>
            <Grid size={{ md: 6, xs: 12 }}>
              <Typography sx={styleCss.CommonLabelName}>Last name:</Typography>
              <TextField
                variant="outlined"
                size="small"
                placeholder="Last name"
                fullWidth
                name="last_name"
                disabled={!isEditable}
                value={formik.values.last_name}
                onChange={formik.handleChange}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f3f3f5",
                    borderRadius: "8px",
                    minHeight: "32px",
                    padding: 0,
                    "& input": {
                      padding: "12px 10px",
                      fontSize: "15px",
                      "&::placeholder": {
                        fontSize: "15px",
                        color: "#717182",
                        opacity: 1,
                        fontFamily: '"Segoe UI", sans-serif',
                      },
                    },
                    "& fieldset": { borderColor: "#ddd" },
                    "&:hover fieldset": { borderColor: "#bbb" },
                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                  },
                  "& .MuiInputLabel-root": {
                    fontFamily: '"Segoe UI", sans-serif',
                    fontSize: "15px",
                    color: "#364252",
                  },
                }}
              />
            </Grid>
            <Grid size={{ md: 6, xs: 12 }}>
              <Typography sx={styleCss.CommonLabelName}>Email:</Typography>
              <TextField
                variant="outlined"
                size="small"
                placeholder="Email"
                fullWidth
                disabled
                value={formik.values.email}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f3f3f5",
                    borderRadius: "8px",
                    minHeight: "32px",
                    padding: 0,
                    "& input": {
                      padding: "12px 10px",
                      fontSize: "15px",
                      "&::placeholder": {
                        fontSize: "15px",
                        color: "#717182",
                        opacity: 1,
                        fontFamily: '"Segoe UI", sans-serif',
                      },
                    },
                    "& fieldset": { borderColor: "#ddd" },
                    "&:hover fieldset": { borderColor: "#bbb" },
                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                  },
                  "& .MuiInputLabel-root": {
                    fontFamily: '"Segoe UI", sans-serif',
                    fontSize: "15px",
                    color: "#364252",
                  },
                }}
              />
            </Grid>
            <Grid size={{ md: 6, xs: 12 }}>
              <Typography sx={styleCss.CommonLabelName}>Phone:</Typography>
              <TextField
                variant="outlined"
                size="small"
                placeholder="Phone"
                fullWidth
                disabled
                value={formik.values.phone_number}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f3f3f5",
                    borderRadius: "8px",
                    minHeight: "32px",
                    padding: 0,
                    "& input": {
                      padding: "12px 10px",
                      fontSize: "15px",
                      "&::placeholder": {
                        fontSize: "15px",
                        color: "#717182",
                        opacity: 1,
                        fontFamily: '"Segoe UI", sans-serif',
                      },
                    },
                    "& fieldset": { borderColor: "#ddd" },
                    "&:hover fieldset": { borderColor: "#bbb" },
                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                  },
                  "& .MuiInputLabel-root": {
                    fontFamily: '"Segoe UI", sans-serif',
                    fontSize: "15px",
                    color: "#364252",
                  },
                }}
              />
            </Grid>
            <Grid size={{ md: 6, xs: 12 }}>
              <Typography sx={styleCss.CommonLabelName}>
                Date of Birth:
              </Typography>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label=""
                  value={formik.values.dob ? dayjs(formik.values.dob) : null}
                  onChange={(newValue) => setStartDate(newValue)}
                   disabled={!isEditable}
                  slots={{
                    openPickerIcon: isEditable ? undefined : () => null,
                  }}
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                      placeholder: "Date of Birth",
                      sx: {
                        "& .MuiPickersSectionList-root": { height: "45px" },
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f3f3f5",
                          borderRadius: "8px",
                          height: "55px",
                          minHeight: "40px",
                          "& input": {
                            padding: "12px 10px",
                            fontSize: "15px",
                            "&::placeholder": {
                              fontSize: "15px",
                              color: "transparent",
                              opacity: 1,
                              fontFamily: '"Segoe UI", sans-serif',
                            },
                          },
                          "& fieldset": { borderColor: "#ddd" },
                          "&:hover fieldset": { borderColor: "#bbb" },
                          "&.Mui-focused fieldset": {
                            borderColor: "transparent",
                          },
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            {/* <Grid size={{ md: 6, xs: 12 }}>
                            <Typography sx={styleCss.CommonLabelName}>Date of Birth:</Typography>
                            <TextField
                                variant="outlined"
                                size="small"
                                placeholder="Date of Birth"
                                fullWidth
                                value={profiledata.dob || ""}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#f3f3f5",
                                        borderRadius: "8px",
                                        minHeight: "32px",
                                        padding: 0,
                                        "& input": {
                                            padding: "12px 10px",
                                            fontSize: "15px",
                                            "&::placeholder": {
                                                fontSize: "15px",
                                                color: "#717182",
                                                opacity: 1,
                                                fontFamily: '"Segoe UI", sans-serif',
                                            },
                                        },
                                        "& fieldset": { borderColor: "#ddd" },
                                        "&:hover fieldset": { borderColor: "#bbb" },
                                        "&.Mui-focused fieldset": { borderColor: "transparent" },
                                    },
                                    "& .MuiInputLabel-root": {
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: "15px",
                                        color: "#364252",
                                    },
                                }}
                            />
                        </Grid> */}

            <Grid size={{ md: 6, xs: 12 }}>
              <Typography sx={styleCss.CommonLabelName}>Gender:</Typography>

              {isEditable ? (
                // ✅ Editable Dropdown
                <TextField
                  select
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formik.values.gender || ""}
                  onChange={(e) => {
                    formik.setFieldValue("gender", e.target.value);
                    setProfileData({ ...profiledata, gender: e.target.value });
                  }}
                  SelectProps={{ native: true }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#f3f3f5",
                      borderRadius: "8px",
                      minHeight: "32px",
                      padding: 0,
                      "& select": {
                        padding: "12px 10px",
                        fontSize: "15px",
                        color: "#364252",
                        fontFamily: '"Segoe UI", sans-serif',
                      },
                      "& fieldset": { borderColor: "#ddd" },
                      "&:hover fieldset": { borderColor: "#bbb" },
                      "&.Mui-focused fieldset": { borderColor: "transparent" },
                    },
                    "& .MuiInputLabel-root": {
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "15px",
                      color: "#364252",
                    },
                  }}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </TextField>
              ) : (
                // ✅ Disabled Text Display
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formik.values.gender || "—"} // shows dash if empty
                  disabled
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#f3f3f5",
                      borderRadius: "8px",
                      minHeight: "32px",
                      "& input": {
                        padding: "12px 10px",
                        fontSize: "15px",
                        color: "#364252",
                        fontFamily: '"Segoe UI", sans-serif',
                      },
                      "& fieldset": { borderColor: "#ddd" },
                    },
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid size={{ md: 4, xs: 12 }}>
        <Box
          sx={{
            padding: "15px 20px",
            borderRadius: "20px",
            border: "1px solid #e5e5e5",
            backgroundColor: "#fff",
            textAlign: "center",
            marginBottom: "15px",
          }}
        >
          <Grid container spacing={2}>
            <Grid size={{ md: 12, xs: 12 }}>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "17px",
                  fontWeight: 600,
                  textAlign: "left",
                  color: "#0e182b",
                  marginBottom: "10px",
                }}
              >
                Quick Stats
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid size={{ md: 8, xs: 8 }}>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "13px",
                  fontWeight: "normal",
                  textAlign: "left",
                  color: "#717182",
                  marginBottom: "10px",
                }}
              >
                <img
                  alt=""
                  src={TotalIconBook}
                  style={{ verticalAlign: "middle", marginRight: "5px" }}
                />{" "}
                Total Bookings
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "13px",
                  fontWeight: "normal",
                  textAlign: "left",
                  color: "#717182",
                  marginBottom: "10px",
                }}
              >
                <img
                  alt=""
                  src={TotalIconBook1}
                  style={{ verticalAlign: "middle", marginRight: "5px" }}
                />{" "}
                Cities Visited
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "13px",
                  fontWeight: "normal",
                  textAlign: "left",
                  color: "#717182",
                }}
              >
                <img
                  alt=""
                  src={TotalIconBook2}
                  style={{ verticalAlign: "middle", marginRight: "5px" }}
                />{" "}
                Rating
              </Typography>
            </Grid>
            <Grid size={{ md: 4, xs: 4 }}>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "15px",
                  fontWeight: 600,
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: "normal",
                  letterSpacing: "normal",
                  textAlign: "right",
                  color: "#030213",
                  marginBottom: "10px",
                }}
              >
                {/* 24 */}
                {formik.values.number_of_booking}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "15px",
                  fontWeight: 600,
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: "normal",
                  letterSpacing: "normal",
                  textAlign: "right",
                  color: "#030213",
                  marginBottom: "10px",
                }}
              >
                {/* 8 */}

                {formik.values.cities_visited}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "15px",
                  fontWeight: 600,
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: "normal",
                  letterSpacing: "normal",
                  textAlign: "right",
                  color: "#030213",
                }}
              >
                4.8/5
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            padding: "15px 20px",
            borderRadius: "20px",
            border: "1px solid #e5e5e5",
            backgroundColor: "#fff",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Segoe UI", sans-serif',
              fontSize: "17px",
              fontWeight: 600,
              textAlign: "left",
              color: "#0e182b",
              marginBottom: "15px",
            }}
          >
            Saved Routes
          </Typography>

          {routes.length > 0 &&
            routes.map((route, index) => (
              <Grid
                key={index}
                container
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderRadius: "10px",
                  border: "1px solid #e5e5e5",
                  marginBottom: "10px",
                }}
              >
                <Grid>
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "left",
                      color: "#030213",
                    }}
                  >
                    {/* Chennai → Bengaluru */}
                    {route.origin_name && route.destination_name
                      ? `${route.origin_name} → ${route.destination_name}`
                      : ""}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "left",
                      color: "#717182",
                    }}
                  >
                    {/* 12 bookings */}
                    {route.visited_count
                      ? `${route.visited_count} booking${
                          route.visited_count > 1 ? "s" : ""
                        }`
                      : ""}
                  </Typography>
                </Grid>
                <Grid>
                  <img src={LocationImg} alt="" />
                </Grid>
              </Grid>
            ))}

          {/* <Grid container sx={{
                        display: 'flex', justifyContent: 'space-between',
                        padding: '10px',
                        borderRadius: '10px',
                        border: '1px solid #e5e5e5',
                        marginBottom: '10px',
                    }}>
                        <Grid>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                textAlign: 'left',
                                color: '#030213',
                            }}>Mumbai → Pune</Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                textAlign: 'left',
                                color: '#717182',
                            }}>
                                12 bookings
                            </Typography>
                        </Grid>
                        <Grid>
                            <img src={LocationImg} alt="" />
                        </Grid>
                    </Grid> */}
          {/* <Grid container sx={{
                        display: 'flex', justifyContent: 'space-between',
                        padding: '10px',
                        borderRadius: '10px',
                        border: '1px solid #e5e5e5',
                        marginBottom: '10px',
                    }}>
                        <Grid>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                textAlign: 'left',
                                color: '#030213',
                            }}>Mumbai → Pune</Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                textAlign: 'left',
                                color: '#717182',
                            }}>
                                12 bookings
                            </Typography>
                        </Grid>
                        <Grid>
                            <img src={LocationImg} alt="" />
                        </Grid>
                    </Grid> */}
        </Box>
      </Grid>
    </Grid>
  );
};

export default MyProfile;
